import BaseMixin from "@/mixins/http/Base";
import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import ClientAgent from "@/models/Agents/Agent";
import QueryableInterface from "@/interfaces/QueryableInterface";

export const enum AgentMixinTags {
  GetAgents = "get_agents",
}

@Component
export default class AgentMixin extends BaseMixin {
  getAgents(
    slug: string,
    tag: string,
    params: QueryableInterface
  ): Promise<ClientAgent[]> {
    const queryString = this.paramsToQueryString(params);
    const url = API_ENDPOINT + `/${slug}/agents/agents.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }
}
